export function defaultKeytipExecute(el, keytipExecute) {
    el && el.focus();
    keytipExecute && keytipExecute(el);
}
export function menuItemInMenuOnExecute(executeTarget, contextualItem) {
    executeTarget.focus();
    if (contextualItem.current) {
        contextualItem.current.openSubMenu();
    }
}
export function itemInMenuOnExecute(executeTarget, contextualItem, keytipExecute) {
    executeTarget.focus();
    if (contextualItem.current) {
        contextualItem.current.dismissMenu(true);
    }
    keytipExecute();
}
//# sourceMappingURL=keytipExecution.js.map